
(function() {
  var result = { translations: { "el": { "i18n": { "duration": { "seconds": "{{ seconds }} \u03B4\u03B5\u03C5\u03C4.", "minutes": "{{ minutes }} \u03BB\u03B5\u03C0\u03C4.", "hours": "{{ hours }} \u03CE\u03C1.", "hoursAndMinutes": "{{ hours }} \u03CE\u03C1. {{ minutes }} \u03BB\u03B5\u03C0\u03C4.", "days": "{{ days }} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2", "shortForm": { "seconds": "{{ seconds }}\u03B4.", "minutes": "{{ minutes }}\u03BB.", "hours": "{{ hours }}\u03CE\u03C1.", "days": "{{ days }}\u03B7\u03BC.", "hoursAndMinutes": "{{ hours }}\u03CE\u03C1. {{ minutes }}\u03BB." } }, "dateTime": { "quarterAndYear": "{{quarterNumber}}\u03BF \u03C4\u03C1\u03AF\u03BC. {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u03B5\u03C3\u03C9\u03C4. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "el": "static-7.1189"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1189",
    "ar-eg": "static-7.1189",
    "bg": "static-7.1189",
    "bn": "static-7.1189",
    "ca-es": "static-7.1189",
    "cs": "static-7.1189",
    "da": "static-7.1189",
    "de": "static-7.1189",
    "el": "static-7.1189",
    "en-gb": "static-7.1189",
    "en": "static-7.1189",
    "es-mx": "static-7.1189",
    "es": "static-7.1189",
    "et": "static-7.1189",
    "fi": "static-7.1189",
    "fr-ca": "static-7.1189",
    "fr": "static-7.1189",
    "he-il": "static-7.1189",
    "hi": "static-7.1189",
    "hr": "static-7.1189",
    "hu": "static-7.1189",
    "id": "static-7.1189",
    "it": "static-7.1189",
    "ja": "static-7.1189",
    "ko": "static-7.1189",
    "lt": "static-7.1189",
    "ms": "static-7.1189",
    "nl": "static-7.1189",
    "no": "static-7.1189",
    "pl": "static-7.1189",
    "pt-br": "static-7.1189",
    "pt-pt": "static-7.1189",
    "ro": "static-7.1189",
    "ru": "static-7.1189",
    "sk": "static-7.1189",
    "sl": "static-7.1189",
    "sv": "static-7.1189",
    "th": "static-7.1189",
    "tl": "static-7.1189",
    "tr": "static-7.1189",
    "uk": "static-7.1189",
    "vi": "static-7.1189",
    "x-pseudo": "static-7.1189",
    "zh-cn": "static-7.1189",
    "zh-hk": "static-7.1189",
    "zh-tw": "static-7.1189"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:el', {version: 'static-7.1189'}); }
})();


